module.exports = __webpack_public_path__ + "img/245.f3f15437.jpg";